<template>
  <va-card>
    <va-button @click="getSvcPublications" style="white-space: nowrap;">export csv</va-button>
    <va-data-table
      ref="vuetable"
      :fields="fields"
      :data="items"
      :loading="loading"
      :totalPages="totalPages"
      @page-selected="readItems"
      api-mode
    >
      <template slot="lender" slot-scope="props">
        <div>
          {{`${props.rowData.lender.first_name} ${props.rowData.lender.last_name}`}}
        </div>
      </template>
      <template slot="rental_price" slot-scope="props">
        <div>
          {{`${props.rowData.rental_price}$`}}
        </div>
      </template>
      <template slot="discount_price" slot-scope="props">
        <div>
          {{`${props.rowData.discount_price}$`}}
        </div>
      </template>
      <template slot="actions" slot-scope="props">
        <router-link :to="{name: 'publications-single', params:{id:props.rowData.id}}">
          <va-button>{{ $t('publications.more')}}</va-button>
        </router-link>
        <va-button :disabled="deleteItemLoading" @click="deleteItem(props.rowData.id)" color="danger">{{ $t('publications.delete') }}</va-button>
      </template>
    </va-data-table>
  </va-card>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Publications-list',
  data() {
    return {
      loading: true,
      page: 1,
      limit: 10,
      ordering: '',
      deleteItemLoading: false,
    }
  },
  computed: {
    ...mapState({
      items: state => state.Publications.items,
      totalPages: state => state.Publications.totalPages,
      hasMore: state => state.Publications.isHave,
    }),
    fields() {
      return [
        {
          name: 'title',
          title: this.$t('publications.list.title'),
        },
        {
          name: '__slot:lender',
          title: this.$t('publications.list.lenderFullName'),
        },
        {
          name: '__slot:rental_price',
          title: this.$t('publications.single.rental_price'),
        },
        {
          name: '__slot:discount_price',
          title: this.$t('publications.single.discount_price'),
        },
        {
          name: 'category.name',
          title: this.$t('publications.list.categoryName'),
        },
        {
          name: '__slot:actions',
        },
      ]
    },
  },
  methods: {
    test(data) { console.log(data) },
    ...mapActions('Publications', ['getItems', 'delete', 'getSvcPublications']),
    async readItems(page = this.page) {
      this.loading = true
      this.page = page
      await this.getItems({ limit: this.limit, page: this.page, ordering: this.ordering })
      this.loading = false
    },
    async deleteItem(id) {
      this.deleteItemLoading = true
      await this.delete(id)
      this.deleteItemLoading = false
    },
  },
  async created() {
    this.loading = true
    await this.getItems({ limit: this.limit, page: this.page, ordering: this.ordering })
    this.loading = false
  },
}
</script>
